import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

export class DropdownList extends Component {
  state = {
    open: false
  };

  static propTypes = {
    elementsList: PropTypes.array,
    styles: PropTypes.string
  };

  render() {
    const { elementsList, styles } = this.props;
    const { open } = this.state;
    return (
      <div className={styles}>
        <div className="span-arrow-dropdown-list" onClick={() => this.setState({ open: !open })}>
          <span
            className={`back-arrow ${this.state.open ? 'custom-icons-up-chevron' : 'custom-icons-down-chevron'} `}
          />
        </div>
        <div
          className={open ? 'dropdown-list-elements-container' : 'dropdown-list-elements-container hide-dropdown-list'}
        >
          {elementsList}
        </div>
      </div>
    );
  }
}
